<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.country?.id"
					/>
				</div>

				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setVisaCategory"
						:options="multiSelectState.visaCategory"
						rules="required"
						name="Visa Category"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.visaCategory ? data.visaCategory : ''"
					/>
				</div>
				<div class="form-group col-sm-4">
					<BaseMultiSelect
						@update:value="setVisitType"
						:options="multiSelectState.visitType"
						rules="required"
						name="Visit Type"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.visitType ? data.visitType : ''"
					/>
				</div>
				<div class="from-group col-sm-4">
					<BaseInput
						name="Duration"
						label="Duration"
						type="number"
						v-model="data.duration"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-4 my-2">
					<label for="durationType" class="small custom-dark-text mb-2"
						>Duration Type</label
					>
					<select
						v-model="data.durationType"
						class="form-select form-select-sm"
						aria-label=".form-select-sm example"
						id="durationType"
						required
					>
						<option
							class="custom-dark-text custom-dark-bg"
							selected
							value="Day/s"
						>
							Day/s
						</option>
						<option class="custom-dark-text custom-dark-bg" value="Month/s">
							Month/s
						</option>
						<option class="custom-dark-text custom-dark-bg" value="Year/s">
							Year/s
						</option>
					</select>
				</div>

				<div class="from-group col-sm-4">
					<BaseInput
						name="Date"
						label="Travel Date"
						type="date"
						:min="`${new Date().toISOString().split('T')[0]}`"
						v-model="data.travelDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="from-group col-sm-4">
					<BaseInput
						name="Job Profile"
						label="Job Profile"
						type="text"
						v-model="data.jobProfile"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-4">
					<BaseInput
						name="Age"
						label="Age"
						type="number"
						:min="18"
						v-model="data.age"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-12 mb-">
					<BaseTextArea
						v-model="data.qualification"
						name="Qualification"
						label="Qualification"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";
	import Data from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";
	import BaseTextArea from "./BaseTextArea";

	export default {
		name: "LeadVisa",
		components: {
			BaseInput,
			BaseMultiSelect,
			BaseTextArea,
		},
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Array, Object, String], default: "" },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				country: {
					id: 0,
					name: null,
				},
				visitType: null,
				visaCategory: null,
				travelDate: null,
				duration: null,
				durationType: null,
				jobProfile: null,
				age: null,
				qualification: null,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.country.name && data.travelDate && data.duration) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				visaCategory: Data.visaCategory,
				visitType: Data.visitType,
				hotels: [],
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
			};

			const setVisaCategory = (category) => {
				if (!category) return;

				data.visaCategory = category;
			};

			const setVisitType = (type) => {
				if (!type) return;
				data.visitType = type;
			};

			if (
				props.defaultData instanceof Array ||
				props.defaultData instanceof Object
			) {
				let keys = Object.keys(data);
				keys.map((key) => (data[key] = props.defaultData[key] || data[key]));
				data.travelDate = props.defaultData?.travelDate.split("T")[0];
			}

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setCountry,
				setVisaCategory,
				setVisitType,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
